import { Injectable } from '@angular/core';
let allyhealthLogo = require("../../assets/logo.png");
let bnLogo = require("../../assets/bnlogo.png");
let cadrLogoFav = require("../../assets/CADRlogo.svg");
let cadrLogo = require("../../assets/CADr/CADR_Web.png");

@Injectable({
  providedIn: 'root'
})
export class FlavourDomainService {

  constructor() { }
  domain(){
    if(window.location.host.includes('localhost') || window.location.host=='192.168.6.99:9200'){
      // return {'name':"Call A Doctor Plus",'key':'CADR','logo':cadrLogo, 'favicon':cadrLogoFav}
      // return  {'name':"Benefits Navigator",'key':'BN','logo':bnLogo, 'favicon':bnLogo}
      return {'name':"Allyhealth",'key':'allyhealth','logo':allyhealthLogo, 'favicon':allyhealthLogo}

    }
    if(window.location.host.includes('benefitsnavigator')){
      return  {'name':"Benefits Navigator",'key':'BN','logo':bnLogo, 'favicon':bnLogo}
      
    }
    if(window.location.host.includes('allyhealth')){
      return {'name':"Allyhealth",'key':'allyhealth','logo':allyhealthLogo, 'favicon':allyhealthLogo}
      
    }
    if(window.location.host.includes('cadrplus')){
      return {'name':"Call A Doctor Plus",'key':'CADR','logo':cadrLogo, 'favicon':cadrLogoFav}
      
    }
  }
}
